import QuickPrintPdf from "./QuickPrintPdf.component";

export default QuickPrintPdf;